import React from "react";
import { SearchState, UsedSources } from "./semantic_search.types.js";
import styles from './AnswerComponent.module.css';

interface AnswerComponentProps {
    chatGptEnabled: boolean;
    answer?: string;
    usedSources?: UsedSources[];
    searchstate: SearchState;
}

export const AnswerComponent: React.FC<AnswerComponentProps> = ({
    chatGptEnabled,
    answer,
    usedSources,
    searchstate,
}) => {
    if (!chatGptEnabled) {
        return null;
    }

    const renderContent = () => {
        if (searchstate === SearchState.LoadingSources) {
            return (
                <div className={styles.loaderContainer}>
                    <div className={styles.loader}></div>
                    <span>Quellen werden geladen...</span>
                </div>
            );
        }

        if (searchstate === SearchState.ValidatingSources) {
            return (
                <div className={styles.loaderContainer}>
                    <div className={styles.loader}></div>
                    <span>Quellen werden analysiert...</span>
                </div>
            );
        }

        if (answer) {
            if (usedSources?.length === 0) {
                return <div className={styles.placeholder}>Die Antwort konnte nicht aus den Quellen ermittelt werden.</div>;
            }
            return <div>{answer}</div>;
        }

        return <div className={styles.placeholder}>Bitte geben Sie eine Frage ein.</div>;
    };

    return (
        <div className={styles.container}>
            <div className={styles.title}>Antwort</div>
            <div className={styles.content}>
                {renderContent()}
            </div>
        </div>
    );
};